module.exports = __webpack_public_path__ + "img/icon-user.5d5ed503.svg";